// Mixtures Vuex

import state from './mixtureStates.js'
import * as getters from './mixtureGetters.js'
import * as mutations from './mixtureMutations.js'
import * as actions from './mixtureActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
